import { render, staticRenderFns } from "./irish-life.vue?vue&type=template&id=232f7113&"
import script from "./irish-life.vue?vue&type=script&lang=js&"
export * from "./irish-life.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports